import { collections } from "@/mocks/daily";

const skin = [
  {
    band: "from-primary-500 to-primary-400",
    dot: "bg-primary-100 text-primary-700",
    arrow: "text-primary-500",
    count: "text-primary-600",
  },
  {
    band: "from-secondary-500 to-secondary-400",
    dot: "bg-secondary-100 text-secondary-700",
    arrow: "text-secondary-600",
    count: "text-secondary-700",
  },
  {
    band: "from-accent-500 to-accent-400",
    dot: "bg-accent-100 text-accent-800",
    arrow: "text-accent-600",
    count: "text-accent-700",
  },
];

export default function Collections() {
  return (
    <section id="collections" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center md:text-left">
          <p className="text-xs font-semibold tracking-widest text-primary-600 uppercase">Curated Lists</p>
          <h2 className="mt-2 font-serif text-2xl md:text-4xl font-black text-foreground-950">
            本周<span className="text-primary-500">专题合集</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-600">把同一主题的热点串成一条清晰的脉络，一读到底</p>
        </div>

        <div className="mt-8 grid gap-6 lg:grid-cols-3">
          {collections.map((c, i) => {
            const s = skin[i];
            return (
              <article
                key={c.cat}
                className="flex flex-col overflow-hidden rounded-xl bg-background-100 border border-background-200"
              >
                <div className={`bg-gradient-to-r ${s.band} px-5 py-4 text-background-50`}>
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-medium tracking-wide text-background-100 opacity-90">{c.tag}</span>
                    <span className="font-serif text-3xl font-black opacity-30">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <h3 className="mt-1 font-serif text-xl font-bold">{c.cat}</h3>
                </div>
                <ul className="flex-1 space-y-3 p-5">
                  {c.items.map((it) => (
                    <li key={it} className="flex items-start gap-2.5 text-sm leading-snug text-foreground-700">
                      <i className={`ri-arrow-right-line mt-0.5 shrink-0 text-sm ${s.arrow}`} aria-hidden="true"></i>
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
                <div className="flex items-center justify-between border-t border-background-200 px-5 py-3 text-xs text-foreground-500">
                  <span>{c.items.length} 篇精选内容</span>
                  <span className={`font-medium ${s.count}`}>持续更新中</span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}